module.exports = __webpack_public_path__ + "static/media/icon4.0d732650.svg";